import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { IndividualSearchSchema } from '../-zod-schema';

export const Route = createFileRoute(
  '/_staff/settings/persons/_list/_account/individual/',
)({
  validateSearch: zodValidator(IndividualSearchSchema),
  loaderDeps: ({ search }) => ({ search }),
  shouldReload: true,
});
